<template>
    <el-drawer
		title="新增"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"                
                ref="formData"
				:rules="rules"
            >				
				<el-form-item prop="name" label="名称:">
				    <el-input v-model="formData.name" placeholder="请输入名称" size="medium"></el-input>
				</el-form-item>
				<el-form-item prop="userId" label="ID:">
				    <el-input v-model="formData.userId" placeholder="请输入ID" size="medium"></el-input>
				</el-form-item>
				<el-form-item prop="avatar" label="头像:">
					<div class="form-flex">
						<image-upload 
				            :url.sync="formData.avatar" 
				            :urlFull.sync="formData.avatar" >
				        </image-upload>
					</div>				    
				</el-form-item>
				<el-form-item label="类型:" prop="type">
					<el-select v-model="formData.type" placeholder="请选择" size="small">
					    <el-option label="最佳现场" :value="2"></el-option>
					    <el-option label="最具潜力" :value="3"></el-option>
						<el-option label="最佳厂牌" :value="5"></el-option>
						<el-option label="最佳场地" :value="4"></el-option>
						<el-option label="最佳体验音乐节" :value="6"></el-option>
						<el-option label="最具人气" :value="7"></el-option>
						<el-option label="年度音乐人" :value="8"></el-option>
						<el-option label="特殊贡献" :value="9"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="风格:" prop="styleId" v-if="formData.type == 2 || formData.type == 7 " :rules="[{ required: formData.type == 2 || formData.type == 7 ? true : false, message: '请选择风格', trigger: 'change' }]">
					<el-select v-model="formData.styleId" placeholder="请选择" size="small">
					    <el-option label="摇滚" :value="1"></el-option>
					    <el-option label="hiphop" :value="2"></el-option>
						<el-option label="民谣" :value="3"></el-option>
						<el-option label="流行" :value="4"></el-option>
						<el-option label="另类" :value="5"></el-option>
						<el-option label="海外" :value="6"></el-option>
					</el-select>
				</el-form-item> 
				<el-form-item prop="isWin" label="是否获奖:">
					<el-radio-group v-model="formData.isWin" size="medium">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>				
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" 
				:loading="btnLoading"
				@click="submitForm"
             >提交</el-button
            >
        </div> 
    </el-drawer>
</template>

<script>

import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {    
    avatar:'',    
    name: "",
    styleId: "",
	type:'',
	userId:'',
	year:'2026',
	isWin:0
}
export default {
    components:{ImageUpload},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData:{
				...defaultFormData
			},
			rules: {
			    //name: [{ required: true, message: "请填写名称" }],
			    userId: [{ required: true, message: "请填写ID" }],
			   // avatar: [{ required: true, message: "请上传图片" }],
			    type: [{ required: true, message: "请选择类型" }],
			},
            
		}
    },
   
    methods:{        
        close() {            
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        show() {          
           this.drawerShow = true;
        },
		      
        // 表单提交
        submitForm() {
           let self = this;
           
           self.$refs["formData"].validate((valid) => {
               if (valid) {
                   
                   const _url = "/lpa/importData";
                   this.btnLoading = true;                    
					
                   this.$request({
                       url: _url,
                       data: {
                           ...this.formData
                        },
                       method: "post",
                   })
                       .then((res) => {
                           const { state, msg } = res.data;
                           if (state == 1) {
                               this.$emit('update');
                               self.close();
                           } else {
                               self.$message.error(msg || "操作失败,请重试");
                           }
                       })
                       .catch(() => {
                           self.$message.error("操作失败,请重试");
                       })
                       .finally(() => {
                           this.btnLoading = false;
                       });
               } else {
                   return false;
               }
           });
                   
        }
    }
}
</script>

<style lang="scss" scoped>
.form-flex{
    width: 100%;
    overflow: hidden;
}
</style>